var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDarkRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#215B61"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 8h11.407v11.407H8V8z",
  fill: "#F25022"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.593 8H32v11.407H20.593V8z",
  fill: "#7FBA00"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8 20.593h11.407V32H8V20.593z",
  fill: "#00A4EF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.593 20.593H32V32H20.593V20.593z",
  fill: "#FFB900"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiMyMTVCNjEiLz4KPHBhdGggZD0iTTggOEgxOS40MDY3VjE5LjQwNjdIOFY4WiIgZmlsbD0iI0YyNTAyMiIvPgo8cGF0aCBkPSJNMjAuNTkzMyA4SDMxLjk5OTlWMTkuNDA2N0gyMC41OTMzVjhaIiBmaWxsPSIjN0ZCQTAwIi8+CjxwYXRoIGQ9Ik04IDIwLjU5MzRIMTkuNDA2N1YzMkg4VjIwLjU5MzRaIiBmaWxsPSIjMDBBNEVGIi8+CjxwYXRoIGQ9Ik0yMC41OTMzIDIwLjU5MzRIMzEuOTk5OVYzMkgyMC41OTMzVjIwLjU5MzRaIiBmaWxsPSIjRkZCOTAwIi8+Cjwvc3ZnPgo=";
export { SvgDarkRounded as ReactComponent };